module.exports = __webpack_public_path__ + "782068535db062b6a838a4ebbc905134.png";